export const styles = () => ({
  floorPlan: { margin: '20px 0', fontWeight: 'bold' },
});
